import { Button } from '@sapiens/insured-component-library';
import MenuIcon from '@material-ui/icons/Menu';
import ClearIcon from '@material-ui/icons/Clear';
import { MediaBreakpoints, spacing } from 'common/utils/helpers/theme.helpers';
import styled, { css } from 'styled-components';

export const MenuSection = styled.div`
  display: none;

  ${MediaBreakpoints.down('md')} {
    display: block;
  }
`;

export const HamburgerMenuIcon = styled(MenuIcon)`
  height: 32px !important;
  width: 32px !important;
  color: ${({ theme }) => theme.customColors.F994} !important;
`;

interface NavDrawerContainerProps {
  show: boolean;
}

export const NavDrawerContainer = styled.div<NavDrawerContainerProps>`
  display: none;

  ${MediaBreakpoints.down('md')} {
    display: block;
    height: 100vh;
    background-color: ${({ theme }) => theme.customColors.F999};
    box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
    width: 275px;
    position: fixed;
    top: 0;
    right: 0;
    z-index: ${({ theme }) => theme.zIndex.header + 2};
    transform: ${({ show }) => (show ? 'translateX(0)' : 'translateX(100%)')};
    transition: transform 0.3s ease-out;
  }
`;

export const ToggleButton = styled(Button)`
  position: absolute !important;
  top: 16px;
  right: 16px;

  background: none !important;
  border: none !important;
  box-shadow: none !important;
  margin: 0 !important;
  padding: 0 !important;
`;

export const NavDrawerSeeProfileLink = styled.a`
  font-family: 'Eina 03';
  text-decoration: none;
  color: ${({ theme }) => theme.customColors.F998};
`;

export const NavDrawerStyledButton = styled(Button)`
  border: 1px solid ${({ theme }) => theme.palette.neutral.white};
`;

export const CloseIcon = styled(ClearIcon)`
  width: 32px !important;
  height: 32px !important;
  color: ${({ theme }) => theme.palette.neutral.white} !important;
`;

export const NavDrawerContent = styled.div`
  margin-top: ${spacing(16)};
  padding: ${spacing(6)};
`;

export const NavDrawerAccountDetails = styled.div`
  margin-left: ${spacing(3)};
`;
export const NavDrawerLinkSection = styled.div`
  margin: ${spacing(5)} 0;
`;

interface NavDrawerLinkProps {
  isActive?: boolean;
}

const ActiveLinkCss = css`
  color: ${({ theme }) => theme.palette.product.F400};
  background: ${({ theme }) => theme.palette.product.F75};
  font-weight: 600;
`;

export const NavDrawerLink = styled.a<NavDrawerLinkProps>`
  font-family: 'Eina 03';
  padding: ${spacing(4)} ${spacing(6)};
  margin-left: -${spacing(6)};
  margin-right: -${spacing(6)};
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.neutral.white};
  text-decoration: none;
  ${({ isActive }) => isActive && ActiveLinkCss};

  &:hover {
    color: ${({ theme }) => theme.palette.product.F400};
  }
`;

export const Backdrop = styled.div`
  display: none;

  ${MediaBreakpoints.down('md')} {
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: ${({ theme }) => theme.zIndex.header + 1};
  }
`;

export const FileClaimLinkButton = styled.div`
  color: ${({ theme }) => theme.palette.neutral.white} !important;
  text-decoration: none !important;
`;

export const HeaderLinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: ${spacing(23)};
  margin-bottom: ${spacing(1.5)};
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #eaeaea;
  border-radius: 6px;
  cursor: pointer;
`;
